import { Component, OnInit, model, signal } from '@angular/core';
import { CustomerService } from '../../../woo_services.module/CustomerService';
import { RoutingService } from '../../../woo_services.module/RoutingService';
import { CompactCustomer } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'select-customer-to-view-assets-for',
  template: `
    <div class="mt-3">
      <h1>Vilken kunds material vill du se?</h1>
      <dot-loader [visibility]="loading()" description="Hämtar kunder"></dot-loader>
      @if(error()) {
      <h3>{{ error() }}</h3>
      } @if(!loading()) {
      <woo-dropdown
        name="customerSelector"
        [items]="customers()"
        [(ngModel)]="customer"
        inputId="customer-search"
        labelText="Kund"
        [searchAttributes]="['name', 'nickname']"
        notFoundText="Inga kunder hittades."
      ></woo-dropdown>
      <button [disabled]="!customer()?.id" class="button primary-1 margin-top--2x" (click)="goToCustomer()">
        Visa
      </button>
      } @else if(customers().length === 0 && !loading()) {
      <p>Inga kunder hittades.</p>
      }
    </div>
  `,
  standalone: false,
})
export class SelectCustomerToViewAssetsFor implements OnInit {
  error = signal<string | null>(null);
  customers = signal<CompactCustomer[]>([]);
  loading = signal(true);
  customer = model<CompactCustomer | null>(null);

  constructor(private routingService: RoutingService, private customerService: CustomerService) {}

  ngOnInit(): void {
    this.customerService
      .getCustomersForCurrentUser()
      .then((customers) => this.customers.set(customers))
      .catch(() => this.error.set('Kunde inte hämta kunder'))
      .finally(() => this.loading.set(false));
  }

  goToCustomer(): void {
    this.routingService.navigate(['/customer', this.customer()?.id, 'creative_assets'], {
      state: { customerName: this.customer()?.name },
    });
  }
}
